//https://stackoverflow.com/questions/42439504/firebase-error-messages-in-different-languages

import { AuthError } from 'types/auth';

export const firebaseErrors: AuthError = {
    'auth/user-not-found': 'No user corresponding to this email',
    'auth/email-already-in-use': 'The email address is already in use'
};
